import { render, staticRenderFns } from "./WelcomeSlide.vue?vue&type=template&id=c7fa4528"
import script from "./WelcomeSlide.vue?vue&type=script&lang=js"
export * from "./WelcomeSlide.vue?vue&type=script&lang=js"
import style0 from "./WelcomeSlide.vue?vue&type=style&index=0&id=c7fa4528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports